export default "__VITE_ASSET__QKXiokLz__"